import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { User } from '../../../shared/classes/user';
import { MomentModule } from 'angular2-moment';
import { Router } from "@angular/router";
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-my-profile-page',
  templateUrl: './my-profile-page.component.html',
  styleUrls: ['./my-profile-page.component.scss']
})
export class MyProfilePageComponent implements OnInit {
  //Initialize user
  user: User = <User>{};

  //For user info updates
  newFirstName: string;
  newLastName: string;
  newEmail: string;
  newPhoneNumber: string;
  newCompanyName: string;

  //For password updates
  currentPassword: string;
  newPassword: string;
  newPasswordConfirmation: string;

  //Edit state
  editing: boolean = false;
  editing_password: boolean = false;
  infoSuccess: boolean = false;
  infoFail: boolean = false;
  passwordSuccess: boolean = false;
  passwordFail: boolean = false;
  passwordConfirmErr: boolean;

  //State for submitting form and showing
  //error based on it
  submitting: boolean = false;

  //Styling based on state
  editing_email: boolean = false;
  editing_first_name: boolean = false;
  editing_company_name: boolean = false;
  editing_last_name: boolean = false;
  editing_phone_number: boolean = false;

  currentPwFocus: boolean = false;
  newPwFocus: boolean = false;
  retypePwFocus: boolean = false;
  changingPw: boolean = false;

  //For link back to dashboard
  orgId: number;

  constructor(
    private UserService: UserService,
    private router: Router,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle('My Profile');
    this.UserService.getUserInfo()
      .subscribe(res => {
        //Parse the user info into JSON
        this.user = User.toUser(res);
        let u: any = JSON.parse(JSON.stringify(this.user));
        //console.log(this.user)
        this.orgId = (u.organizations || [])[0].id;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  //Go back to last page
  goBack() {
    window.history.back();
  }

  //Cancel edit
  cancelEdit(userForm: NgForm) {
    this.editing = false;
    userForm.reset();
  }

  //Update user info
  updateUser(userForm: NgForm) {
    //Set state of submitted so we can show errors now
    this.submitting = true;

    //Set the data that is being updated or use existing data
    let data = {
      first_name: this.newFirstName ? this.newFirstName : this.user.first_name,
      last_name: this.newLastName ? this.newLastName : this.user.last_name,
      email: this.newEmail ? this.newEmail : this.user.email,
      phone_number: this.newPhoneNumber ? this.newPhoneNumber : this.user.phone_number,
      company_name: this.newCompanyName ? this.newCompanyName : this.user.company_name
    }

    if (userForm.invalid) {
      return;
    } else {
      this.submitting = false;
      this.UserService.updateUser(this.user.id, data)
        .subscribe(
        //Handle correct response
        res => {
          //Remove editing state
          this.editing = false;
          //Update model to show changes
          this.updateModel(data);
          //Clear form
          userForm.reset();
          //Show changes successful for period of time
          this.infoSuccess = true;
          setTimeout(() => {
            this.infoSuccess = false;
          }, 5000);
        },

        //Handle errors
        error => {
          //Set visual for errors
          this.infoFail = true;
          setTimeout(() => {
            this.infoFail = false;
          }, 5000);
        }
        )
    }
  }

  //Update model for user fields
  updateModel(data: any) {
    this.user.first_name = data.first_name;
    this.user.last_name = data.last_name;
    this.user.email = data.email;
    this.user.phone_number = data.phone_number;
    this.user.company_name = data.company_name;
  }

  updatePassword(pwForm: NgForm) {
    this.changingPw = true;
    if (pwForm.invalid) {
      return;
    }
    //Set the password data that is being updated    
    let data = {
      current_password: this.currentPassword,
      password: this.newPassword,
      password_confirmation: this.newPasswordConfirmation
    }

    if (data.password === data.password_confirmation) {
      // Send Request to change password
      this.UserService.updatePassword(this.user.id, data)
        .subscribe(
        //Handle correct response
        res => {
          //Remove editing state
          this.changingPw = false;
          //Set visual indication
          this.passwordSuccess = true;

          setTimeout(() => {
            this.passwordSuccess = false;
          }, 5000);
        },
        //Handle errors
        error => {
          //Set visual indication of what is wrong
          this.passwordFail = true;
          setTimeout(() => {
            this.passwordFail = false;
          }, 5000);
        }
        )
    } else {
      // Highlight the fields saying they need to be the same
      this.passwordConfirmErr = true;
      setTimeout(() => {
        this.passwordConfirmErr = false;
      }, 5000);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/my-profile-page/my-profile-page.component.ts